import axios from 'axios'
import { uniqBy } from 'lodash'
import { COMMISSIONS_ENDPOINT } from '../../../common/endpoints'

export async function getCommissionData(commissionPeriodId) {
  const response = await axios.get(
    `${COMMISSIONS_ENDPOINT}/listByPeriod/${commissionPeriodId}`
  )
  const data = response?.data?.data
  const refreshDate = response?.data?.refresh_date
 
  const carlotOptions = uniqBy(
    data.map(d => ({ label: d.car_lot, value: d.car_lot })),
    'label'
  )

  return { data, carlotOptions, refreshDate }
}
